// Components==============
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from 'components/UI/Button/Button';
import RichTextEditor from 'components/UI/RichTextEditor/RichTextEditor';
import TrainingContentCard from 'components/UI/TrainingContentCard/TrainingContentCard';
import { useTranslate } from 'hooks/useTranslate';
import {
  AttachmentType,
  TrainingBuilderContext,
} from 'pages/Workspace/TrainingBuilder/TrainingBuilder';
import React, { useContext } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import './ExtraInfo.module.scss';

// =========================

export default function ExtraInfo() {
  const {
    handleRemoveAttachment,
    attachments,
    setAttachments,
    handleAddExtraInfo,
    handleReorderExtraInfo,
  } = useContext(TrainingBuilderContext);

  const translate = useTranslate();

  return (
    <div styleName="wrapper">
      <p styleName="bottom-title">
        {translate('course.actions.add-information-to-course')}
      </p>
      {!!attachments.length && (
        <DragDropContext onDragEnd={handleReorderExtraInfo}>
          <Droppable droppableId="attachments">
            {(provided) => (
              <div
                {...provided.droppableProps}
                ref={provided.innerRef}
                styleName="grid"
              >
                {attachments
                  .filter((a) => a.attachment_type === 'text')
                  .sort((a, b) => a.order_index - b.order_index)
                  .map((attachment, i) => (
                    <TrainingContentCard
                      key={i}
                      index={i}
                      id={attachment.id}
                      handleRemove={() => handleRemoveAttachment(attachment.id)}
                    >
                      <div styleName="extra-info-wrapper">
                        <input
                          styleName="title"
                          maxLength={50}
                          defaultValue={attachment?.data?.title}
                          placeholder={
                            translate('general.terms.title') as string
                          }
                          onChange={(e) =>
                            setAttachments((prev) =>
                              prev.map((a) =>
                                a.id === attachment.id
                                  ? ({
                                      ...a,
                                      data: {
                                        ...a.data,
                                        title: e.target.value,
                                      },
                                      changed: true,
                                    } as AttachmentType)
                                  : a
                              )
                            )
                          }
                        />
                        <div styleName="text">
                          <RichTextEditor
                            initial={attachment.data?.text || ''}
                            onChange={(val) =>
                              setAttachments((prev) =>
                                prev.map((a) =>
                                  a.id === attachment.id
                                    ? ({
                                        ...a,
                                        data: {
                                          ...a.data,
                                          text: val,
                                        },
                                        changed: true,
                                      } as AttachmentType)
                                    : a
                                )
                              )
                            }
                          />
                        </div>
                      </div>
                    </TrainingContentCard>
                  ))}
                {provided.placeholder}
              </div>
            )}
          </Droppable>
        </DragDropContext>
      )}
      <div styleName="button">
        <Button color="grey" onClick={handleAddExtraInfo}>
          <FontAwesomeIcon icon={faPlus} />
          {translate('course.actions.add-information-to-course-button')}
        </Button>
      </div>
    </div>
  );
}
